import * as React from "react";
import { useState } from "react";
import { observer } from "mobx-react";
import { Button } from "@chakra-ui/react";
import { t } from "i18next";
import { useStores } from "../../../../../shared/stores/RootStore";

const RouteMatchingControlsBase: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const { craNodeStore, craWayStore } = useStores();

  const way = craWayStore.getSelected()!;

  const matchRoute = async () => {
    setLoading(true);
    const nodes = craNodeStore.getMultiSelectedNodesByCraWay(way.id);
    await craNodeStore.matchRoute(nodes!);
    setLoading(false);
  };

  return (
    <Button
      fontSize={"sm"}
      colorPalette="primary"
      size="sm"
      loading={loading}
      onClick={matchRoute}
      disabled={craNodeStore.multiSelectedIds.size < 2}
    >
      {t(`craway:mapBoxMatching.mapboxMatchButton`)}
    </Button>
  );
};

export const RouteMatchingControls = observer(RouteMatchingControlsBase);
